/* eslint-disable camelcase */

define('tealium-utils',['require','exports','module','lodash','mixpanel-helper','lib/set-language'],function (require, exports) {
    var _ = require('lodash');
    var mixpanelHelper = require('mixpanel-helper');
    var setLanguage = require('lib/set-language');

    exports.setupTealium = function (token) {
        /* eslint-disable */
        // Token is needed for setting language, so abort setup if no token is given
        if (!token) {
            return;
        }

        // Tealium Universal Data Object
        window.utag_data = {
            pageset: 'default',
            product: 'g2m',
            section: 'postlogin',
            sub_section: 'myaccount',
            language: 'en',
            region: 'US'
        };

        return setLanguage().then(function () {
            var tealiumUrl = '//tags.tiqcdn.com/utag/lmi/collaboration-postlogin/dev/utag.js';
            if (window.location.href.indexOf('global.gotomeeting.com') > -1) {
                tealiumUrl = '//tags.tiqcdn.com/utag/lmi/collaboration-postlogin/prod/utag.js';
            }

            // Getting Tealium utag.js from Tealium IQ
            return (function (a, b, c, d) {
                a = tealiumUrl;
                b = document;
                c = 'script';
                d = b.createElement(c);
                d.src = a;
                d.type = 'text/java' + c;
                d.async = true;
                a = b.getElementsByTagName(c)[0];
                a.parentNode.insertBefore(d, a);
            })();
        })
    };

    function sendTealiumEvent (content_type, template) {
        if (!content_type || !template) {
            throw new Error('content_type and template parameters are required');
        }

        _.assign(window.utag_data, {
            content_type: content_type,
            template: template
        });

        /**
         * Sends the Universal Data Object (UDO) to the tealium IQ
         */
        if (window.utag) {
            window.utag.view(window.utag_data);
        }
    }

    exports.sendTealiumEvent = sendTealiumEvent;

    /**
    * Extracts language and region set through user settings, used to send data to Tealium for Marketing Analytics
    */
    exports.updateTealiumLocaleData = function (localeResponse) {
        var locale = localeResponse.split('_');
        var language = locale[0];
        var region = locale[1];

        if (window.utag_data) {
            if (language) {
                window.utag_data.language = language;
            }

            if (region) {
                window.utag_data.region = region;
            }
        } else {
            console.log('No Locale set for tracking, utag_data is missing');
        }
    };

    /**
     * Accepts durandal router as a parameter and adds an event listener
     * that gets fired every time SPA page composition is complete
     * Google Tag Manager uses this even as a que to send
     * virtual page view event to Google Analytics
     */
    exports.trackVirtualPages = function (router) {
        router.on('router:navigation:complete', function (model, instruction) {
            var pageName = false;
            var content_type = false;
            var template = false;
            // Keep all routes lowercase, since URLs are not case sensitive
            var fragment = instruction.fragment.toLowerCase();
            
            function setDefaultContentTypeAndTemplate() {
                content_type = 'meetings';
                template = 'my-meetings';
            }

            switch (fragment) {
                case '':
                    setDefaultContentTypeAndTemplate();
                    break;
                case 'meetings':
                    setDefaultContentTypeAndTemplate();
                    break;
                case 'meetings/upcoming':
                    pageName = 'Upcoming Meetings';
                    setDefaultContentTypeAndTemplate();
                    break;
                case 'meetings/welcome':
                    content_type = 'meetings';
                    template = 'welcome-meeting';
                    break;
                case 'meetings/past':
                    pageName = 'Past Meetings';
                    content_type = 'meetinghistory';
                    template = 'meeting-history';
                    break;
                case 'settings':
                    pageName = 'Settings';
                    content_type = 'settings';
                    template = 'settings';
                    break;
                case 'beta':
                    content_type = 'meetings';
                    template = 'beta';
                    break;
                case 'labs':
                    pageName = 'Labs';
                    content_type = 'meetings';
                    template = 'labs';
                    break;
                case 'setup':
                    content_type = 'meetings';
                    template = 'setup';
                    break;
                case 'setup/reserve':
                    pageName = 'Setup Reserve';

                    // Do not handle Tealium here, since the free trial (judo flip) page
                    // does not have a distinct URL and must be tracked separately
                    break;
                case 'setup/start':
                    template = 'setup_start';
                    content_type = 'meetings';
                    break;
                case 'pagenotfound':
                    pageName = 'Page Not Found';
                    template = 'pagenotfound';
                    content_type = 'meetings';
                    break;
                case 'inviteusers':
                    pageName = 'Invite Users';
                    break;
                default:
                    break;
            }

            if (pageName) {
                window.mixpanel.register({'Current Page': pageName});
                mixpanelHelper.track('Navigate to ' + pageName);
            }

            if (content_type && template) {
                sendTealiumEvent(content_type, template);
            }
        });
    };
});

